import { HeaderProps } from './header.types'
import { Header as HeaderUI } from '@touche-lts/panel-ui/dist'
import { observer } from 'mobx-react-lite'
import { Notifications } from './notifications'
import { Profile } from './profile'
import styles from './header.module.scss'
import cl from 'classnames'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'

const HeaderComponent = (props: HeaderProps) => {
  const { className, style } = props
  const {
    routingStore: { push },
    notificationsStore: {
      getNotifications,
      notificationsSet
    }
  } = useRootStore()

  useEffect(() => {
    const interval = setInterval(() => getNotifications(), 300000);
    return () => {
      clearInterval(interval);
    };
  }, [getNotifications])


  return (
    <>
      {notificationsSet ? (
        <HeaderUI
          className={cl(styles.container, className)}
          style={style}
          onLogoClick={() => push('/')}
          notificationsComponent={Notifications}
          profileComponent={Profile}
        />
      ) : (
        <HeaderUI
          className={cl(styles.container, className)}
          style={style}
          onLogoClick={() => push('/')}
          notificationsComponent={Notifications}
          profileComponent={Profile}
        />
      )}
    </>
  )
}

const Header = observer(HeaderComponent)
export { Header }
